import { configureStore } from '@reduxjs/toolkit'
import authSlice from './features/auth/authSlice'
import cmsSlice from './features/cms/cmsSlice'
// import memberSlice from './features/memberSlice'
import membershipSlice from './features/membershipSlice'
import themes from './features/themes'

const store = configureStore({
  reducer: {
    auth: authSlice,
    cms: cmsSlice,
    // member: memberSlice,
    membership: membershipSlice,
    themes: themes,
  },
  preloadedState: {},
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'cms/setItems',
          'cms/setOption',
          'cms/syncOptions',
          'cms/loadProperties',
          'membership/setMember',
          'membership/syncMemberCoupons',
          'membership/syncRedeems',
        ],
        ignoredPaths: ['cms', 'auth', 'membership'],
      },
    }),
})

export default store
